if (!customElements.get('side-panel-links-lookbook')) {
  class LookSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawernew = document.getElementById('Product-Lookbook-Drawer');
      this.buttonsnew = this.drawernew.querySelector('.side-panel-content--tabs');
      this.panelsnew = this.drawernew.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          /* ZUMO custom: open through 17.0's OverlayManager (overlay stack, body.open-cc,
             inert, focus trap/return, panel:open), as vanilla side-panel-links.js does.
             OverlayManager is a top-level const in the classic app.js script, so it is
             referenced by bare name and guarded with typeof. The 8.1 class toggling is
             kept as a fallback (app.js OverlayManager.closeLast() still closes it). */
          if (typeof OverlayManager !== 'undefined') {
            OverlayManager.open(this.drawernew);
          } else {
            this.body.classList.add('open-cc');
            this.drawernew.classList.add('active');
          }
        });
      }); 
      
    }
  }

  customElements.define('side-panel-links-lookbook', LookSidePanelLinks);

}